<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="mr-2">
        <b-button size="sm" variant="primary" @click="onBack()">
          <font-awesome-icon icon="chevron-left"/>
          Назад
        </b-button>
      </b-navbar-nav>
      <b-navbar-nav class="mx-2">
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row align-v="center">
          <b-col cols="auto">
            <b-button size="sm" variant="success" :disabled="loading" @click="handleSubmit()">
              <b-spinner v-if="loading" small></b-spinner>
              Сохранить
            </b-button>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>
    <b-card no-body>
      <b-form @submit.stop.prevent="handleSubmit">
        <b-container fluid class="my-2">
          <b-row>
            <b-col>
              <b-card bg-variant="light">
                <b-row>
                  <b-col lg="2" md="4">
                    <b-form-group label="Период">
                      <month-picker
                        v-model="newItem.period"
                        placeholder="Выберите период"
                        :min-year="2025"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col lg="2" md="4">
                    <b-form-group
                      id="group-salary-date"
                      label="Дата"
                      label-for="input-salary-date"
                    >
                      <b-form-input
                        id="input-salary-date"
                        size="sm"
                        type="date"
                        v-model.date="newItem.payment_date"/>
                    </b-form-group>
                  </b-col>

                  <b-col lg="3" md="4">
                    <b-form-group
                      id="group-salary-organization"
                      label="Организация"
                      label-for="input-organization-select"
                    >
                      <organization-select
                        id="input-organization-select"
                        ref="organization_select"
                        class="mb-1 mr-2"
                        :value="newItem.organization_id"
                        @onSelect="onSelectOrganization"
                      />
                    </b-form-group>
                  </b-col>

                </b-row>
                <b-row>
                  <b-col lg="2" md="4">
                    <b-form-group
                      id="group-salary-type"
                      label="Тип выплаты"
                      label-for="input-salary-type"
                    >
                      <b-form-select
                        id="input-salary-type"
                        size="sm"
                        v-model="newItem.type_id"
                      >
                        <option v-for="option in types" :value="option.id">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col lg="2" md="4">
                    <b-form-group
                      id="group-salary-code"
                      label="Номер"
                      label-for="input-salary-code"
                    >
                      <b-form-input
                        id="input-salary-code"
                        type="text"
                        size="sm"
                        v-model="newItem.code"
                        trim />
                    </b-form-group>
                  </b-col>

                  <b-col lg="2" md="4">
                    <b-form-group
                      id="group-salary-income-type"
                      label="Вид дохода"
                      label-for="input-salary-income-type"
                    >
                      <b-form-select
                        id="input-salary-income-type"
                        size="sm"
                        v-model="newItem.income_type_id"
                      >
                        <option v-for="option in incomeTypes" :value="option.id">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col lg="3" md="4">
                    <b-form-group
                      id="group-salary-comment"
                      label="Комментарий"
                      label-for="input-salary-comment"
                    >
                      <b-form-input
                        id="input-salary-comment"
                        type="text"
                        size="sm"
                        v-model="newItem.comment"
                        trim />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col cols="3">
              <b-card no-body bg-variant="light">
                <b-card-header>
                  <h6 id="task-header">Итого</h6>
                </b-card-header>
                <b-list-group flush bg-variant="light">
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Выплачено
                    <strong>{{priceFormat(totalAmount)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    НДФЛ
                    <strong>{{priceFormat(totalNdflAmount)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Страховые
                    <strong>{{priceFormat(totalInsuranceAmount)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Пенс. до превыш.
                    <strong>{{priceFormat(totalPensionBeforeAmount)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Пенс. после превыш.
                    <strong>{{priceFormat(totalPensionAfterAmount)}}</strong>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>

        </b-container>
      </b-form>

      <salary-staff-list :salary="newItem" @change="onChangeSalaryStaff"></salary-staff-list>
    </b-card>
  </div>
</template>

<script>
import salaries from "../../network/salaries";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import StaffSelect from "../Staff/StaffSelect";
    import MonthPicker from "../MonthPicker/MonthPicker";
    import OrganizationSelect from "../Organizations/OrganizationSelect";
    import SalaryStaffList from "./SalaryStaffList";

const commonErrorMessage = "Что-то пошло не так. Попробуйте обновить страницу и повторить действие.";

export default {
  name: "Salary",
  components: { SalaryStaffList, StaffSelect, MonthPicker, OrganizationSelect },
  mixins: [
    salaries,
    helpers, dateFormatter
  ],
  data() {
    return {
      title: "Выплата",
      show: false,
      newItem: {
        id: 0,
        period: this.newPeriodDate(),
        payment_date: this.stringDateToInputFromDate(this.newOnlyDate()),
        organization_id: 0,
        organization_name: '',
        type_id: null,
        type_name: '',
        salary_type_id: null,
        salary_type_name: '',
        income_type_id: null,
        income_type_name: '',
        amount_sum: 0,
        quantity_sum: 0,
        ndfl_amount_sum: 0,
        insurance_amount_sum: 0,
        pension_before_amount_sum: 0,
        pension_after_amount_sum: 0,
        code: '',
        status: 'created',
        comment: '',
        active: true,
        salary_staffs: []
      },
      isBusy: false,
      loading: false,
      isDisabled: false,
      types: [],
      salaryTypes: [],
      incomeTypes: [],
    }
  },
  async created() {
    this.types = this.getTypes();
    this.salaryTypes = this.getSalaryTypes();
    this.incomeTypes = this.getIncomeTypes();
    await this.updateView();
  },
  computed: {
    totalAmount() {
      const result = this.newItem.salary_staffs
        .map(obj => obj.amount)
        .reduce((acc, current) => acc + current, 0)

      return Math.round(result * 100) / 100;
    },
    totalNdflAmount() {
      const result = this.newItem.salary_staffs
        .map(obj => obj.ndfl_amount)
        .reduce((acc, current) => acc + current, 0)

      return Math.round(result * 100) / 100;
    },
    totalInsuranceAmount() {
      const result = this.newItem.salary_staffs
        .map(obj => obj.insurance_amount)
        .reduce((acc, current) => acc + current, 0)

      return Math.round(result * 100) / 100;
    },
    totalPensionBeforeAmount() {
      const result = this.newItem.salary_staffs
        .map(obj => obj.pension_before_amount)
        .reduce((acc, current) => acc + current, 0)

      return Math.round(result * 100) / 100;
    },
    totalPensionAfterAmount() {
      const result = this.newItem.salary_staffs
        .map(obj => obj.pension_after_amount)
        .reduce((acc, current) => acc + current, 0)

      return Math.round(result * 100) / 100;
    },
  },
  methods: {
    async updateView() {
      const id = this.$route.params.id;
      if (id) {
        await this.getItem(id);
      }

      let typeId = this.$route.params.type_id;
      if (typeId) {
        this.newItem.salary_type_id = typeId;
      } else {
        typeId = this.newItem.salary_type_id;
      }

      const salaryType = this.salaryTypes.find(x => x.id === typeId);
      if (salaryType != null) {
        this.title = `${salaryType.title}`;
      }
    },
    async getItem(id) {
      this.isBusy = true;
      const result = await this.getSalaryById(id);
      if (result.data == null) {
        this.showError(commonErrorMessage);
        return;
      }

      this.newItem = result.data;

      this.newItem.period = this.dateFromServerString(this.newItem.period);

      const paymentDate = this.dateFromServerString(this.newItem.payment_date);
      this.newItem.payment_date = this.stringDateToInputFromDate(paymentDate);

      if (this.$refs.organization_select != null) {
        await this.$refs.organization_select.configure(this.newItem.organization_id);
      }
    },
    onBack() {
      this.goBack();
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        const path = '/staffs';
        this.$router.push(path).catch(()=>{});
      }
    },
    formattedFromServerDate(date) {
      if (date != null) {
        date = this.formatDate(this.getDateFromServerString(date));
      }
      return date;
    },
    formattedToServerDate(date) {
      if (!this.isDateValid(date)) {
        return null;
      }

      if (date != null) {
        date = this.localISOString(this.getDateToServer(date));
      }

      return date;
    },
    async handleSubmit() {
      if (this.newItem.payment_date == null) {
        this.showError("Укажите Дату");
        return;
      }

      if (this.newItem.organization_id === 0) {
        this.showError("Выберите организацию");
        return;
      }

      if (this.newItem.type_id == null || this.newItem.type_id === 0) {
        this.showError("Выберите тип выплаты");
        return;
      }

      if (this.newItem.salary_type_id === 0) {
        this.showError("Выберите способ выплаты");
        return;
      }

      this.newItem.amount_sum = this.totalAmount;
      this.newItem.ndfl_amount_sum = this.totalNdflAmount;
      this.newItem.insurance_amount_sum = this.totalInsuranceAmount;
      this.newItem.pension_before_amount_sum = this.totalPensionBeforeAmount;
      this.newItem.pension_after_amount_sum = this.totalPensionAfterAmount;

      const data = Object.assign({}, this.newItem);
      // Форматируем даты
      data.period = this.stringDateToServerFromDate(this.newItem.period);
      data.payment_date = this.stringDateToServerFormString(data.payment_date);

      const type = this.types.find(x => x.id === data.type_id);
      if (type != null) {
        data.type_name = type.name;
      }

      const salaryType = this.salaryTypes.find(x => x.id === data.salary_type_id);
      if (salaryType != null) {
        data.salary_type_name = salaryType.name;
      }

      const incomeType = this.incomeTypes.find(x => x.id === data.income_type_id);
      if (incomeType != null) {
        data.income_type_name = incomeType.name;
      }

      if (data.id > 0) {
        const result = await this.putSalary(data);
        if (result.data == null) {
          this.showError(commonErrorMessage);
          return;
        }
        this.newItem.id = result.data.id;
        this.onBack();
      } else {
        const result = await this.postSalary(data);
        if (result.data == null) {
          this.showError(commonErrorMessage);
          return;
        }
        this.newItem.id = result.data.id;
        this.onBack();
      }
    },
    onSelectOrganization(id) {
      this.newItem.organization_id = id;
      if (this.$refs.organization_select != null) {
        this.newItem.organization_name = this.$refs.organization_select.item.name;
      }
    },
    onChangeSalaryStaff(items) {
      this.newItem.salary_staffs = items;
    },

    getTypes() {
      return [
        {
          id: 1,
          name: 'Ведомость в банк'
        },
        {
          id: 2,
          name: 'На руки'
        },
      ]
    },
    getSalaryTypes() {
      return [
        {
          id: 1,
          name: 'Аванс',
          title: 'Выплата Аванса',
        },
        {
          id: 2,
          name: 'Зарплата',
          title: 'Выплата Зарплаты',
        },
        {
          id: 3,
          name: 'Отпуск',
          title: 'Выплата Отпуска',
        },
        {
          id: 4,
          name: 'Премия',
          title: 'Выплата Премии',
        },
        {
          id: 5,
          name: 'Аванс Сдельно',
          title: 'Выплата Аванса Сдельно',
        },
        {
          id: 6,
          name: 'Зарплата Сдельно',
          title: 'Выплата Зарплаты Сдельно',
        },
        {
          id: 7,
          name: 'Премия Сдельно',
          title: 'Выплата Премии Сдельно',
        },
      ]
    },
    getIncomeTypes() {
      return [
        {
          id: 1,
          name: 'Заработная плата'
        },
        {
          id: 1,
          name: 'Заработная плата Сдельно'
        },
      ]
    },

  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Salary/Salary.vue